import { c as _c } from "react/compiler-runtime";
import { ComponentProps, useEffect, useMemo, useState } from 'react';
import { DEFAULT_LOCALE, localeToSupportedTranslationFile } from 'constants/settings';
import { defaultMessages, IntlProvider, messages } from 'locales/index';
import { LocalesType } from '@commutifi-fe/constants';
import { UiComponentsConfigProvider, useConfig, AppThemes, stripePromise } from './UiComponentsConfigProvider';
export { ConfigProvider, useConfig, AppThemes, stripePromise };
function ConfigProvider(t0) {
  const $ = _c(16);
  const {
    children,
    locale: t1
  } = t0;
  const locale = t1 === undefined ? DEFAULT_LOCALE : t1;
  const [isLazyLoadingTranslations, setIsLazyLoadingTranslations] = useState(true);
  const [lazyLoadedMessages, setLazyLoadedMessages] = useState(defaultMessages);
  let t2;
  let t3;
  if ($[0] !== locale) {
    t2 = () => {
      const intlTranslationsName = localeToSupportedTranslationFile(locale);
      if (messages[intlTranslationsName] && process.env.NODE_ENV !== "test") {
        setIsLazyLoadingTranslations(true);
        messages[intlTranslationsName]().then(module => {
          setLazyLoadedMessages(module.default);
          setIsLazyLoadingTranslations(false);
        }).catch(_temp);
      } else {
        setLazyLoadedMessages(defaultMessages);
        setIsLazyLoadingTranslations(false);
      }
    };
    t3 = [locale];
    $[0] = locale;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== lazyLoadedMessages || $[4] !== locale) {
    t4 = locale === DEFAULT_LOCALE ? defaultMessages : {
      ...defaultMessages,
      ...lazyLoadedMessages
    };
    $[3] = lazyLoadedMessages;
    $[4] = locale;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const messagesWithEnglishAsFallback = t4;
  let t5;
  if ($[6] !== locale || $[7] !== messagesWithEnglishAsFallback) {
    t5 = {
      locale,
      messages: messagesWithEnglishAsFallback
    };
    $[6] = locale;
    $[7] = messagesWithEnglishAsFallback;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const intlData = t5;
  let t6;
  if ($[9] !== children || $[10] !== isLazyLoadingTranslations || $[11] !== locale) {
    t6 = <UiComponentsConfigProvider locale={locale} isLoadingTranslations={isLazyLoadingTranslations}>{children}</UiComponentsConfigProvider>;
    $[9] = children;
    $[10] = isLazyLoadingTranslations;
    $[11] = locale;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== intlData || $[14] !== t6) {
    t7 = <IntlProvider {...intlData}>{t6}</IntlProvider>;
    $[13] = intlData;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp() {}
interface AntdConfigProps {
  locale?: LocalesType;
  children: React.ReactNode;
  theme?: ComponentProps<typeof UiComponentsConfigProvider>['theme'];
}